import { render } from "./ProductModules.vue?vue&type=template&id=0b058d79&scoped=true"
import script from "./ProductModules.vue?vue&type=script&lang=js"
export * from "./ProductModules.vue?vue&type=script&lang=js"

import "./ProductModules.vue?vue&type=style&index=0&id=0b058d79&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b058d79"]])

export default __exports__